document.addEventListener('DOMContentLoaded', function() {
	// Registered before the Swiper call (not after) so it always runs regardless of any
	// error inside Swiper's own init - guarantees the brand icons can never get stuck hidden.
	setTimeout(function () {
		document.querySelectorAll('.swiper-brands .swiper-wrapper').forEach(function (wrapper) {
			wrapper.style.display = 'flex';
		});
	}, 1500);

	// Matched to https://www.vivapets.nl's homepage sliders (swiper-1 brands, swiper-6 popular
	// products, swiper-4 blogs): same swipe feel there = no followFinger / touchAngle /
	// touchMoveStopPropagation overrides, threshold 0, and the same slidesPerGroup breakpoints
	// (brands 3/4/6/10, everything else 1/2/3/4). Each .swiper-base element is initialized
	// exactly once, individually (never one call for a selector that matches several elements
	// plus a second call somewhere else - that created stacked duplicate instances before).
	function groups(a, b, c, d) {
		return {
			"@0.0":  { slidesPerGroup: a },
			"@0.75": { slidesPerGroup: b },
			"@1.00": { slidesPerGroup: c },
			"@1.50": { slidesPerGroup: d },
		};
	}

	document.querySelectorAll(".swiper-base").forEach(function (el) {
		var breakpoints;
		if (el.classList.contains("swiper-brands")) {
			breakpoints = groups(3, 4, 6, 10);
		} else if (el.classList.contains("product-variant-gallery__swiper")) {
			// PDP variant swiper is not on the vivapets.nl homepage - left exactly as it was.
			breakpoints = groups(1, 2, 3, 3);
		} else {
			breakpoints = groups(1, 2, 3, 4);
		}

		new Swiper(el, {
			cssMode: false,
			// Swiper 11's default threshold is 5px, Swiper 8 (what vivapets.nl runs) defaults to 0 -
			// set explicitly so the slider reacts to the very first pixel of a drag like the
			// reference does.
			threshold: 0,
			breakpoints: breakpoints,
			slidesPerView: "auto",
			spaceBetween: 10,
			speed: 100,
			activeIndex: 1,
			mousewheel: {
				forceToAxis: true,
			},
			// If we need pagination
			pagination: {
				el: ".swiper-pagination-base",
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 5
			},
			hashNavigation: {
				watchState: true,
			},
			on: {
				// .swiper-brands's wrapper starts hidden (display:none in brand-logos.css) so the
				// spaceBetween margins Swiper adds to each slide right below don't cause a visible
				// snap once they're applied - reveal it the instant this instance is ready. Harmless
				// no-op for every other .swiper-base instance, since only .swiper-brands has that
				// CSS hiding rule in the first place. Swiper calls afterInit with no arguments (only
				// `this` is bound to the instance) - use `this.el`, not a function parameter.
				afterInit: function () {
					var wrapper = this.el.querySelector('.swiper-wrapper');
					if (wrapper) wrapper.style.display = 'flex';
				},
			},
		});
	});
});